import React, { useCallback, useEffect, useReducer } from "react";

import Table from "./partials/Table";
import FilterForm from "./partials/FilterForm";
import Summary from "./partials/Summary";
import { useCookies } from "react-cookie";
import { getList, getSummary, getChannels } from "../../../controller/api/__classic__/unmarketable-tickets";
import { calculatePage } from "../../../helper/helper";

export const Context = React.createContext(null);

const initialData = {
  filter: {
    fromDate: '',
    toDate: '',
    channelId: 'all',
    rewardCalculated: 'all',
    winningStatus: 'all',
    page: 0
  },
  data: {
    list: [],
    total: 0,
    totalPage: 0
  },
  summary: {
    total: 0,
    totalAmount: 0,
    totalRewardAmount: 0,
    wonCount: 0,
    wonAmount: 0,
    wonRewardAmount: 0,
    notWonCount: 0,
    notWonAmount: 0,
    pendingCount: 0,
    pendingAmount: 0,
  },
  channels: [],
  filterPressCount: 0,
  isLoading: false,
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'SUBMIT_FILTER':
      return {
        ...state,
        filter: {
          ...action.payload,
          page: 0
        },
        filterPressCount: state.filterPressCount + 1
      }
    case 'UPDATE_DATA':
      return {
        ...state,
        data: {
          ...action.payload
        }
      }
    case 'UPDATE_SUMMARY':
      return {
        ...state,
        summary: {
          ...action.payload
        }
      }
    case 'UPDATE_CHANNELS':
      return {
        ...state,
        channels: action.payload
      }
    case 'UPDATE_PAGE':
      return {
        ...state,
        filter: {
          ...state.filter,
          page: action.payload
        }
      }
    case 'SET_LOADING':
      return {
        ...state,
        isLoading: Boolean(action.payload)
      }
    default:
      return {
        ...state
      }
  }
}

export default () => {

  var [state, dispatch] = useReducer(reducer, initialData);

  const [cookies] = useCookies(['lottmekong'])

  const getChannelsFunc = useCallback(async () => {
    const response = await getChannels(cookies.lottmekong)
    if (response && response.data) {
      dispatch({
        type: 'UPDATE_CHANNELS',
        payload: response.data
      })
    }
  }, [cookies.lottmekong])

  const getAllFunc = useCallback(async () => {
    dispatch({ type: 'SET_LOADING', payload: true });

    const query = {
      fromDate: state.filter.fromDate || undefined,
      toDate: state.filter.toDate || undefined,
      channelId: state.filter.channelId,
      rewardCalculated: state.filter.rewardCalculated,
      winningStatus: state.filter.winningStatus,
    }

    try {
      const response = await getList(cookies.lottmekong, query, state.filter.page)

      if (response) {
        dispatch({
          type: 'UPDATE_DATA',
          payload: {
            list: response.data,
            total: response.total,
            totalPage: calculatePage(response.total)
          }
        })
      }

      const summaryResponse = await getSummary(cookies.lottmekong, query)
      if (summaryResponse) {
        dispatch({
          type: 'UPDATE_SUMMARY',
          payload: summaryResponse
        })
      }
    } finally {
      dispatch({ type: 'SET_LOADING', payload: false });
    }
  }, [cookies.lottmekong, state.filter])

  useEffect(() => {
    getChannelsFunc()
  }, [getChannelsFunc])

  useEffect(() => {
    getAllFunc()
  }, [getAllFunc, state.filterPressCount, state.filter.page])

  useEffect(() => {
    document.title = "Vé ế"
  }, []);

  return (
    <Context.Provider value={{
      state,
      dispatch
    }}>

      <FilterForm />

      <br />

      <Summary />

      <br />

      <Table />
    </Context.Provider>
  );
};
